/* PARFUMPROBEN VERSAND – Popup „Alle Marken“ (sections/parfumproben-markenwelten.liquid).
   Öffnet über „Alle Marken ›“ und die Kachel „Alle Marken anzeigen“ (ohne JavaScript: Link zur Markenseite).
   Esc / Klick auf den Hintergrund schließt, Fokus bleibt im Dialog, die Seite scrollt währenddessen nicht.
   Suche filtert live über den Markennamen und blendet „Beliebt“ aus. */
(() => {
  if (window.__PPV_BRANDS__) return;
  window.__PPV_BRANDS__ = true;

  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const normalize = value => String(value || '').toLocaleLowerCase('de').normalize('NFD').replace(/[̀-ͯ]/g, '').trim();

  function init(section) {
    const dialog = section.querySelector('[data-ppv-brands-dialog]');
    if (!dialog) return;
    const panel = dialog.querySelector('.ppv-brands-dialog__panel');
    const search = dialog.querySelector('[data-ppv-brands-search]');
    const popular = dialog.querySelector('[data-ppv-brands-popular]');
    const groups = [...dialog.querySelectorAll('[data-ppv-brands-group]')];
    const empty = dialog.querySelector('[data-ppv-brands-empty]');
    const body = dialog.querySelector('.ppv-brands-dialog__body');
    const entries = groups.map(group => [...group.querySelectorAll('[data-ppv-brands-entry]')].map(entry => ({ entry, name: normalize(entry.textContent) })));
    let opener = null;

    /* An <body> hängen: kein Vorfahre mit transform/overflow kann das fixierte Popup beschneiden. */
    document.body.appendChild(dialog);

    function filter() {
      const term = normalize(search.value);
      let visible = 0;
      groups.forEach((group, index) => {
        let count = 0;
        entries[index].forEach(({ entry, name }) => {
          const match = !term || name.includes(term);
          entry.hidden = !match;
          if (match) count += 1;
        });
        group.hidden = count === 0;
        visible += count;
      });
      if (popular) popular.hidden = term !== '';
      if (empty) empty.hidden = visible !== 0;
    }

    function open(trigger) {
      opener = trigger || document.activeElement;
      dialog.hidden = false;
      document.documentElement.classList.add('ppv-brands-lock');
      document.documentElement.style.overflow = 'hidden';
      body.scrollTop = 0;
      const coarse = window.matchMedia('(pointer: coarse)').matches;
      window.setTimeout(() => (coarse ? panel.querySelector('.ppv-brands-dialog__close') : search)?.focus({ preventScroll: true }), 30);
    }

    function close() {
      if (dialog.hidden) return;
      dialog.hidden = true;
      document.documentElement.classList.remove('ppv-brands-lock');
      document.documentElement.style.overflow = '';
      search.value = '';
      filter();
      opener?.focus?.({ preventScroll: true });
    }

    section.querySelectorAll('[data-ppv-brands-open]').forEach(trigger => {
      trigger.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
        event.preventDefault();
        open(trigger);
      });
    });

    dialog.querySelectorAll('[data-ppv-brands-close]').forEach(element => element.addEventListener('click', close));
    search.addEventListener('input', filter);

    dialog.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        if (search.value && document.activeElement === search) {
          search.value = '';
          filter();
          return;
        }
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll(FOCUSABLE)].filter(element => !element.closest('[hidden]') && element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  const start = () => document.querySelectorAll('[data-ppv-brands]').forEach(section => {
    if (section.dataset.ppvReady) return;
    section.dataset.ppvReady = 'true';
    init(section);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  /* Theme-Editor: das an <body> gehängte Popup der alten Section-Fassung entfernen. */
  document.addEventListener('shopify:section:unload', event => {
    document.getElementById(`PpvBrandsDialog-${event.detail?.sectionId}`)?.remove();
    document.documentElement.style.overflow = '';
  });
  document.addEventListener('shopify:section:load', start);
})();
